import Immutable from 'seamless-immutable';
import _ from 'lodash';

import RefData from 'ref-data';

import { enums } from 'console-kit';

import { cloudinaryService } from '../../common/Services';

/**
 * Winner
 * @typedef {object} Winner
 * @property {boolean} confirmed is the entry confirmed
 * @property {string} entryId the entry id
 * @property {number} the place id
 * @property {string} place the winner status of the winner entry
 *
 */

const winnerStatuses = RefData.Collection.hydrateAll(RefData.Enum.STATUS.ENTRY_WINNER)
  .asMutable()
  .filter((entry) => !!entry.order)
  .sort((a, b) => {
    if (a.order < b.order) {
      return -1;
    } else if (b.order < a.order) {
      return 1;
    } else {
      return 0;
    }
  })
  .map((entry) => ({
    text:  entry.name,
    value: entry.value,
  }));

function create(winner = _defaultWinner) {
  const result = _.clone(winner);
  return Immutable(result, { prototype: model });
}

function deserialize(winner) {
  const result = _.pick(winner, _keys);

  result.firstName = _.get(winner, 'entry.firstName', '');
  result.lastName = _.get(winner, 'entry.lastName', '');
  result.email = _.get(winner, 'entry.email', '');
  result.network = _.get(winner, 'entry.network', '');
  result.source = _.get(winner, 'entry.source', '');

  result.collectionId = _.get(winner, 'entry.collectionId');
  result.contentId = _.get(winner, 'entry.contentId');

  // place can also contain the value 'archive' so we need to be careful here to check we have the appropriate values
  result.place = _.get(
    _.find(winnerStatuses, (s) => {
      return s.value === winner.place;
    }),
    'text',
    ''
  );

  result.isInvalidated = winner.invalidated;
  return create(result);
}

const model = {
  get avatarRef() {
    return `${this.network}:${this.sourceUserName || ''}:${this.sourceUserId || ''}`;
  },
  get avatarUrl() {
    return cloudinaryService.avatarUrlFromRef(this.avatarRef);
  },
  get dataIcon() {
    return this.isInvalidated ? enums.icons.WARNING : enums.icons.CONTEST;
  },
  get winnerName() {
    const name = _.reduce(
      [this.firstName, this.lastName],
      (name, v) => {
        if (!!v) name.push(v);
        return name;
      },
      []
    );
    return `${name.join(' ')}`;
  },
  get winnerNameLabel() {
    return `${this.winnerName ? this.winnerName : this.email || this.sourceUserName}`;
  },
};

const _keys = ['archived', 'entryId', 'id', 'place', 'sourceUserName', 'sourceUserId'];

const _defaultWinner = {};

export default {
  create,
  deserialize,
};
